import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPinned = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" {...props}>
    <path
      d="M5.835 9.542 2.657 6.364l3.898-.72 3.704-3.091.232-1.082 3.461 3.46-1.12.195L9.753 8.84l-.732 3.887zm1.589 1.603-6.931 3.89L4.305 8.07z"
      fill="#FFF"
      fillRule="evenodd"
      stroke="#17181A"
      strokeWidth={0.967}
    />
  </svg>
);
const Memo = memo(SvgPinned);
export default Memo;
